export function getRangeAges(ages: number[], range: number): number[][] {
  let splittedAges = [ages[0]];
  let next = ages[0] + range;

  while (next <= ages[1]) {
    splittedAges.push(next);
    next = next + range;
  }

  return splittedAges.map((value: number) => [value, value + (range - 1) > ages[1] ? ages[1] : value + (range - 1)]);
}
